import { buildValidator } from "./buildValidator";

export const phone = buildValidator("Please enter a valid mobile phone number", (value, input) => {
  const rsRequired = input?.getAttribute("rsrequired");

  const matchWidth = input?.getAttribute("data-match-with");
  if (matchWidth) {
    const matchWithValue = (document.querySelector(`[rsMonitor =${matchWidth}]`) as HTMLInputElement)?.value;
    if (matchWithValue) {
      return (
        typeof value === "string" &&
        /^(?:\+1)?(?:\(\d{3}\)|\d{3})[ -]?\d{3}[ -]?\d{4}$/.test(value.trim()) &&
        value.trim() === matchWithValue.trim()
      );
    } else {
      return true;
    }
  } else {
    if (rsRequired && /\{val:false,/.test(rsRequired) && !value) {
      return true;
    }
    return (
      !!value && typeof value === "string" && /^(?:\+1)?(?:\(\d{3}\)|\d{3})[ -]?\d{3}[ -]?\d{4}$/.test(value.trim())
    );
  }
});
